module.exports = "<p>\r\n  update-rentai-inquiry works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/rentalInquiry/update-rentai-inquiry/update-rentai-inquiry.component.html
// module id = ../../../../../src/app/rentalInquiry/update-rentai-inquiry/update-rentai-inquiry.component.html
// module chunks = main